import http from "./http";
import { wOrgIdMiddleware } from "../utils/commonUtils";

const ComplianceMonitorService = {
  getList: wOrgIdMiddleware(async (url, query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    const response = await http.GET(`${url}compliance-monitor?${queryString}`);
    return response?.data || response;
  }, true),

  getById: wOrgIdMiddleware(async (url, id) => {
    const response = await http.GET(`${url}compliance-monitor/${id}`);
    return response?.data || response;
  }, true),

  create: wOrgIdMiddleware(async (url, payload) => {
    const response = await http.POST(`${url}compliance-monitor`, payload);
    return response;
  }, true),

  update: wOrgIdMiddleware(async (url, id, payload) => {
    const response = await http.PUT(`${url}compliance-monitor/${id}`, payload);
    return response;
  }, true),

  remove: wOrgIdMiddleware(async (url, id) => {
    const response = await http.DELETE(`${url}compliance-monitor/${id}`);
    return response;
  }, true),

  getPatientComplianceExams: wOrgIdMiddleware(async (url, employeeId) => {
    const response = await http.GET(`${url}compliance-monitor/patient/${employeeId}/exams`);
    return response?.data || response;
  }, true),

  overridePatientComplianceExam: wOrgIdMiddleware(async (url, employeeId, activityId, payload) => {
    const response = await http.POST(
      `${url}compliance-monitor/patient/${employeeId}/activity/${activityId}/override`,
      payload
    );
    return response;
  }, true),

  togglePatientComplianceReminders: wOrgIdMiddleware(async (url, employeeId, activityId, disabled) => {
    const response = await http.POST(
      `${url}compliance-monitor/patient/${employeeId}/activity/${activityId}/reminders`,
      { disabled }
    );
    return response;
  }, true),
};

export default ComplianceMonitorService;

